<template>
  <el-container class="PageHeader">
    <div class="PageHeader-head" @click="scrollTop">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        v-if="browserContext.up('md')"
        class="PageHeader-head-breadcrumb"
      >
        <el-breadcrumb-item
          v-for="match in breadcrumb"
          :key="match.path"
          :to="match.path ? match : { path: '/' }"
          >
          <span v-if="match.meta.title == 'Programmes'">
            {{ $t("routes.program") }}
          </span>
          <span v-else-if="match.meta.title == 'Lots'">
            {{ $t("routes.lot") }}
          </span>
          <span v-else-if="match.meta.title == 'Annonces'">
            {{ $t("routes.adsTitle") }}
          </span>
          <span v-else>
            {{
              (match.meta && match.meta.title) || match.name || match.path
            }}
          </span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <ubi-icon
        @click="$router.go(-1)"
        name="angle-left"
        v-if="browserContext.down('sm')"
        class="PageHeader-head-back"
      />
      <h1 v-if="this.pagetitle(this.$route)">{{this.pagetitle(this.$route) }}</h1>
    </div>
    <div class="PageHeader-actions">
      <slot></slot>
    </div>
  </el-container>
</template>

<script>
import { Breadcrumb, BreadcrumbItem } from 'element-ui'

/**
 * En-tête de page
 */
export default {
  name: 'UbiPageHeader',
  components: {
    ElBreadcrumb: Breadcrumb,
    ElBreadcrumbItem: BreadcrumbItem
  },
  inject: ['browserContext'],
  props: {
    title: String
  },
  computed: {
    breadcrumb () {
      return (
        this.$route.matched.filter(({ meta }) => !meta || !meta.root) || []
      ).slice(0, -1)
    }
  },
  methods: {
    pagetitle (route) {
      return `${route.meta.title}` || this.title || ((this.$route.meta && this.$route.meta.title) || this.$route.name)
    },
    scrollTop () {
      if (this.browserContext.down('sm')) window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.PageHeader {
  align-items: center;
  justify-content: space-between;
  color: $white;

  &-head {
    h1 {
      @extend .mb-0, .pb-0;
      color: $white;
      border: 0;
    }

    &-breadcrumb {
      .el-breadcrumb__separator,
      .el-breadcrumb__inner {
        font-weight: lighter !important;
        font-size: $font-size-xs;
        color: $white !important;
        opacity: 0.5;
      }
    }
  }

  &-actions {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  @include media-breakpoint-up(md) {
    margin-top: map-get($spacers, 3);
    margin-bottom: map-get($spacers, 3);
  }

  @include media-breakpoint-down(md) {
    flex-direction: column;

    &-head {
      align-self: flex-start;

      h1 {
        margin-bottom: map-get($spacers, 0) !important;
        padding-bottom: 0 !important;
      }
    }

    &-actions {
      align-self: flex-end;
    }
  }

  @include media-breakpoint-down(sm) {
    color: $white;

    &-head {
      height: 50px;
      align-items: center;
      border-bottom: 1px solid $blue;
      display: flex;
      justify-content: flex-start;
      padding: map-get($spacers, 2);
      width: 100%;

      h1 {
        font-size: $font-size-base-alt;
        border-bottom: 0;
        margin: 0 !important;
        padding: 0 !important;
      }

      &-back {
        align-items: center;
        display: flex;
        height: 36px;
        justify-content: center;
        margin-right: map-get($spacers, 3);
        width: 36px;
      }
    }

    &-actions {
      padding: map-get($spacers, 3);
      text-align: right;
      width: 100%;

      .el-button {
        padding-top: map-get($spacers, 2);
        padding-bottom: map-get($spacers, 2);
      }
    }
  }
}
/* Pour IPAD PRO */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  .PageHeader{
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>
